const routes = [
  {
    url: /\/user\/user-details\/.*/,
    method: 'Get',
    reply: function (request) {
      const baseUserDetails = {
        usersId: 'bcebd372-bdb2-49f0-91e8-6391a1d7ab8f',
        userName: 'MyClear Local',
        userLogin: 'my.clear@clear.sale',
        userEmail: 'my.clear@clear.sale',
        userCellPhone: '(11) 12345-6789',
        userIsSuperUser: false,
        userLegacyId: 10,
        userCreatedOn: Date.now(),
        userIsActive: true,
        userIsInternal: true,
        entitiesQuantity: 1,
        entities: [
          {
            entitiesId: '16b6d522-21f3-4fd5-b813-a58519f43ce4',
            entityName: 'MyClear Enttidade',
            entityLegacyId: 10,
            products: [
              {
                productsId: '04f61418-7ea5-4f91-9c85-e72d08e8bea4',
                productName: 'Pesquisa de Pedidos',
                productIcon: 'error',
                productUrl: '',
                productType: 0,
                productLegacyId: 10,
                productCreatedOn: Date.now(),
                productUpdateddOn: Date.now(),
                productIsActive: true,
                roles: [
                  {
                    rolesId: '02d4f31b-2086-4f94-a023-bfb9efba2af1',
                    roleLegacyId: 10,
                    roleName: 'Admin',
                    roleIsActive: true
                  }
                ]
              }
            ]
          }
        ]
      }
      return [200, { ...baseUserDetails }]
    }
  },
  {
    url: /\/user\/user-details\/(.*)\?entityName=(.*)/,
    method: 'Get',
    reply: function (request) {
      return [500, null]
    }
  }
]

export default routes
